import { FinancialStatementAccount } from 'src/app/domain/financial-statement/models/common/FinancialStatementAccount';
import { formats, getCell } from '../../../utils';
import { Rows } from '../../../interfaces';
/* eslint-disable quote-props */


export const getPreparedData = (data: FinancialStatementAccount[], headers: string[]): Rows => {
  const rows: Rows = [];
  rows.push(headers);

  const mappedToHeaders = data.map((d) => getNewMapping(d));
  mappedToHeaders.push(getGrandTotalRow(mappedToHeaders.length));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(mapped[header]);
    }
    rows.push(row);
  }

  return rows;
};

const getNewMapping = (data: FinancialStatementAccount) => ({
  'Account Code': data.code,
  'Account Name': data.name,
  'Balance': getCell({ v: data.sums.balance, z: formats.thousandsSeparator, t: 'n' }),
  'isManual': String(data.isManual),
});

// end row of sum is length + 1 because array starts from row 2
const getGrandTotalRow = (rowsLength: number) => ({
  'Account Code': '',
  'Account Name': '',
  'Balance': getCell({ f: `=SUM(C2:C${rowsLength + 1})`, z: formats.thousandsSeparator, t: 'n' }),
  'isManual': '',
});
